// Shared types and interfaces for Babel List.

export interface Language {
  id: string;
  nativeLang: string;
  targetLang: string;
  translit: string;
  checked: boolean;
}

export interface Settings {
  leftLang: string;
  rightLang: string;
  firstRun: string;
  darkMode: string;
}

export type SettingsContextType = {
  settings: Settings;
  setSettings: (settings: Settings) => void;
};

export interface AvailableLangs {
  [key: string]: {
    name: string;
    nativeName: string;
    dir: string;
  };
}

export interface LangChangeContextType {
  langChangeUseEffect: boolean;
  setLangChangeUseEffect: (newState: boolean) => void;
}

// Side of a list item / focus target.
export type Side = "left" | "right";

// A request to move keyboard focus to a particular item's textarea.
// `nonce` increments on every request so the focus effect re-fires even when
// the same id/side is targeted twice in a row.
export type FocusRequest = {
  id: string;
  side: Side;
  nonce: number;
} | null;

// Per-item loading state, keyed by item id.
export type APILoading = {
  [id: string]: { left?: boolean; right?: boolean };
};

export const defaultSettings: Settings = {
  firstRun: "true",
  leftLang: "en",
  rightLang: "ja",
  darkMode: "dark",
};

// Item factory: every item gets a stable id.
export function createItem(partial: Partial<Language> = {}): Language {
  return {
    id: crypto.randomUUID(),
    nativeLang: "",
    targetLang: "",
    translit: "",
    checked: false,
    ...partial,
  };
}

// Back-fill ids on a list loaded from localStorage (older persisted lists have
// no id field).
export function ensureIds(list: Language[]): Language[] {
  return list.map((item) =>
    item.id ? item : { ...item, id: crypto.randomUUID() },
  );
}
